import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {UrlInputComponent} from './url-input.component';

@NgModule({
    imports: [
        PagesSharedModule
    ],
    declarations: [
        UrlInputComponent
    ],
    entryComponents: [],
    exports: [
        UrlInputComponent
    ]
})
export class UrlnputModule {
}
